<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const UserRepository = Repository.get('users')

export default {
  name: 'ActiveUsers',
  props: ['search'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Cédula',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'idNumber',
      },
      {
        text: 'Nombre',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'firstName',
      },
      {
        text: 'Apellido',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'lastName',
      },
      {
        text: 'Rol',
        align: 'center',
        class:
          'primary white--text font-weight-bold text-subtitle-2 rounded-tr-lg',
        value: 'role',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
  }),
  methods: {
    fetchPage: function (params) {
      return UserRepository.get(params)
    },
  },
}
</script>
